import { Row, Col } from 'react-bootstrap';
import { useAppSelector } from '../../hooks';
import classes from './Winner.module.css';
import ShortAddress from '../ShortAddress';
import clsx from 'clsx';
import { isMobileScreen } from '../../utils/isMobile';
import { Trans } from '@lingui/macro';
import { useActiveLocale } from '../../hooks/useActivateLocale';
import { YouWonModal } from '../YouWonModal';
import { BigNumber } from 'ethers';
import { useDisclosure, Button } from '@chakra-ui/react';

interface WinnerProps {
  winner: string;
  isNounders?: boolean;
  teddyId?: BigNumber;
}

const Winner: React.FC<WinnerProps> = props => {
  const { winner, isNounders, teddyId } = props;
  const activeAccount = useAppSelector(state => state.account.activeAccount);
  const youWonModalDisclosure = useDisclosure();

  const isCool = useAppSelector(state => state.application.isCoolBackground);
  const isMobile = isMobileScreen();

  const isWinnerYou =
    activeAccount !== undefined && activeAccount.toLocaleLowerCase() === winner.toLocaleLowerCase();

  const activeLocale = useActiveLocale();

  const nonNounderNounContent = isWinnerYou ? (
    <Row className={classes.youSection}>
      <Col lg={activeLocale === 'ja-JP' ? 8 : 4} className={classes.youCopy}>
        <h2
          className={classes.winnerContent}
          style={{
            fontSize: `28px`,
            color: isCool ? 'var(--brand-cool-dark-text)' : 'var(--brand-warm-dark-text)',
          }}
        >
          <Trans>You</Trans>
        </h2>
      </Col>
      {!isMobile && (
        <Col>
            <Button variant="brand" onClick={youWonModalDisclosure.onOpen}>
              <Trans>What now?</Trans>
            </Button>
        </Col>
      )}
    </Row>
  ) : (
    <ShortAddress size={40} address={winner} avatar={true} />
  );

  const nounderNounContent = 'nounders.eth';

  return (
    <>
      <Row className={clsx(classes.wrapper, classes.section)}>
        <Col xs={1} lg={12} className={classes.leftCol}>
          <h4
            style={{
              color: isCool
                ? "var(--brand-cool-light-text)"
                : "var(--brand-warm-light-text)",
            }}
            className={classes.winnerCopy}
          >
            <Trans>Winner</Trans>
          </h4>
        </Col>
        <Col xs="auto" lg={12}>
          <h2
            className={classes.winnerContent}
            style={{
              color: isCool
                ? "var(--brand-cool-dark-text)"
                : "var(--brand-warm-dark-text)",
            }}
          >
            {isNounders ? nounderNounContent : nonNounderNounContent}
          </h2>
        </Col>
      </Row>
      {isWinnerYou && isMobile && (
        <Row>
            <Button
              variant="brand"
              onClick={youWonModalDisclosure.onOpen}
            >
              <Trans>What now?</Trans>
            </Button>
        </Row>
      )}
      {teddyId &&  (
        <YouWonModal
          isOpen={youWonModalDisclosure.isOpen}
          teddyId={teddyId}
          onClose={youWonModalDisclosure.onClose}
        />
      )}
    </>
  );
};

export default Winner;
